import {
  convertInvoiceV3toInvoiceModel,
  InvoiceModel,
  InvoiceModelV3,
  isInvoiceModelV3,
  PaymentModel,
} from '@frontend/api-invoices';

export const calculatePaymentRefunds = (payment: PaymentModel) => {
  return payment?.refunds?.reduce((refAcc, refund) => refAcc + refund.amount, 0) ?? 0;
};

export const calculateTotalFees = (invoice: InvoiceModel | InvoiceModelV3) => {
  const convertedInvoice = isInvoiceModelV3(invoice) ? convertInvoiceV3toInvoiceModel(invoice) : invoice;

  const totalFees = convertedInvoice.payments?.reduce((acc, payment) => acc + payment.fee, 0) ?? 0;

  return totalFees;
};

export const calculateTotalPaidWithoutRefunds = (invoice: InvoiceModel) => {
  const totalPaid =
    invoice.payments?.reduce((acc, payment) => {
      if (payment.status === 'SUCCEEDED') {
        return acc + payment.paidAmount;
      }
      return acc;
    }, 0) ?? 0;

  return totalPaid;
};

export const calculateTotalNet = (invoice: InvoiceModel | InvoiceModelV3) => {
  const convertedInvoice = isInvoiceModelV3(invoice) ? convertInvoiceV3toInvoiceModel(invoice) : invoice;

  const totalNet =
    convertedInvoice.payments?.reduce(
      (acc, payment) => acc + (payment?.refunds ? payment.net - calculatePaymentRefunds(payment) : payment.net),
      0
    ) ?? 0;

  return totalNet;
};

export const calculatePaidInvoiceTotal = (invoice: InvoiceModel) => {
  const totalPaymentsMinusRefunds =
    invoice.payments?.reduce(
      (acc, payment) =>
        acc +
        (payment?.refunds
          ? payment?.paidAmount - calculatePaymentRefunds(payment)
          : payment.status === 'SUCCEEDED'
          ? payment.paidAmount
          : 0),
      0
    ) ?? 0;

  return totalPaymentsMinusRefunds;
};
